import React from 'react';
import SectionReferencesItem from './SectionReferencesItem';
import references__item from "./references__item";

function SectionReferences() {
    return (
        <section className="references">
            <h2 className="references__heading">HTML references 
                <span className="references__heading--small"> (I have prepared hundreds of HTML / CSS templates):</span>
            </h2>
            <div className="references__list">
                {references__item.map((x,index) => (
                    <SectionReferencesItem
                      href={x.href}
                      key={index}
                      src={x.src}
                      title={x.title}
                    />
                ))}
            </div>
        </section>
    );
}

export default SectionReferences;